<template>
<article class="info-section elr-container-full">
  <div class="elr-row">
    <div class="elr-col-full">
      <info-section-heading>
        Ponies by {{`${capitalize(deslugify(category))}: ${capitalize(deslugify(value))}`}}</info-section-heading>
    </div>
  </div>
  <div class="elr-row">
    <div class="elr-col-full">
      <list-item-grid>
        <PonyCard
          @removedPony="removeCard"
          v-for="item in items"
          :key="item.id"
          :item="item"
          :user="user"
          :authenticated="authenticated"
          :url="url(item.id)"
        />
      </list-item-grid>
    </div>
  </div>
</article>
</template>

<script>
import { mapState } from 'vuex';
import axios from 'axios';
import { capitalize, deslugify, infiniteScroll } from '../../utils/helpers';
import InfoSectionHeading from '../../components/InfoSectionHeading/InfoSectionHeading';
import ListItemGrid from '../../components/ListItemGrid/ListItemGrid';
import PonyCard from '../../components/PonyCard/PonyCard';

export default {
  name: 'Category',
  props: {
    category: {
      type: String,
      required: true
    },
    value: {
      type: String,
      required: true
    }
  },
  components: {
    InfoSectionHeading,
    ListItemGrid,
    PonyCard
  },
  data() {
    return {
      items: [],
      errors: [],
      nextUrl: null,
      currentPage: null,
      num: 12
    };
  },
  mounted() {
    this.fetchPonies(this.category, this.value);
    infiniteScroll(() => {
      this.onFetchMore(this.nextUrl);
    });
  },
  computed: {
    ...mapState({
      authenticated: state => state.currentUser.authenticated,
      user: state => state.currentUser.currentUser
    }),
  },
  methods: {
    capitalize,
    deslugify,
    fetchPonies(category, value) {
      axios
        .get(`${process.env.VUE_APP_ROOT_API}/list/${category}/${value}/ponies/${this.num}`)
        .then(({ data: { data: { heading, items }, links, meta } }) => {
          this.heading = heading;
          this.items = items;
          this.nextUrl = links.next;
          this.current = meta.current_page;
        })
        .catch(e => {
          if (e && e.response) {
            return e.response.data;
          }
        });
    },
    removeCard(payload) {
      this.items = this.items.filter(o => o.id !== payload);
    },
    onFetchMore(url) {
      axios
        .get(url)
        .then(({ data: { data: { items }, links, meta } }) => {
          this.items = this.items.concat(items);
          this.nextUrl = links.next;
          this.current = meta.current_page;
        })
        .catch(e => {
          if (e && e.response) {
            // this.paginationErrors.push(e.response.data);
          }
        });
    },
    url(id) {
      return `/pony/${id}`
    }
  },
  watch: {
    $route() {
      this.items = [];
      this.fetchPonies(this.category, this.value);
    }
  }
};
</script>
